/**
 * @generated SignedSource<<45b7f930746447c13cb67364d9b5a89c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksHomeV2StoryPackageTopicQueue$data = {
  readonly refTerms: ReadonlyArray<{
    readonly __typename: "Newsletter";
    readonly name: string;
  } | {
    readonly __typename: "Section";
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | {
    readonly __typename: "Topic";
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined> | null | undefined;
  readonly settings: unknown | null | undefined;
  readonly " $fragmentType": "hooksHomeV2StoryPackageTopicQueue";
};
export type hooksHomeV2StoryPackageTopicQueue$key = {
  readonly " $data"?: hooksHomeV2StoryPackageTopicQueue$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksHomeV2StoryPackageTopicQueue">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "entityLink"
  },
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksHomeV2StoryPackageTopicQueue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "refTerms",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "type": "Newsletter",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "Section",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "Topic",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "settings",
      "storageKey": null
    }
  ],
  "type": "Queue",
  "abstractKey": null
};
})();

(node as any).hash = "09d97a673280dad12952f2c20bf9cec4";

export default node;
